// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountingExportExtraFieldsController = function ($scope, AccountingExportAvailableFields, AccountingExportSettings) {
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    $scope.tabs = {
        0: {format: "datev", type: "postings", active: true},
        1: {format: "datev", type: "debitors", active: false},
        2: {format: "lexware", type: "postings", active: false},
        3: {format: "lexware", type: "debitors", active: false}
    }

    var selectedTab = 0;

    $scope.selectTab = function (tabNumber) {
        for (let key in $scope.tabs) {
            $scope.tabs[Number(key)].active = false;
        }
        $scope.tabs[tabNumber].active = true;
        selectedTab = tabNumber;
        update();
        triggerFormValidationMessage();
    }

    function triggerFormValidationMessage() {
        let formDomObject = angular.element.find(`[name='form']`)[0];
        formDomObject.reportValidity();
    }

    function update() {
        var key = "ExtraFields" + capitalizeFirstLetter($scope.tabs[selectedTab].type) + capitalizeFirstLetter($scope.tabs[selectedTab].format);
        if ($scope.settings) {
            $scope.extraFields = $scope.settings[key];
        } else {
            $scope.extraFields = null;
        }

        $scope.AvailableOutputsKeyed = {};
        $scope.AvailableFields = AccountingExportAvailableFields.get({
            format: $scope.tabs[selectedTab].format,
            type: $scope.tabs[selectedTab].type
        }, function () {
            if (currentAvailableFields !== $scope.AvailableFields)
                return;
            for (var i = 0; i < $scope.AvailableFields.Outputs.length; i++) {
                var availableOutput = $scope.AvailableFields.Outputs[i];
                $scope.AvailableOutputsKeyed[availableOutput.Key] = availableOutput;
            }
        });
        var currentAvailableFields = $scope.AvailableFields;
    }

    $scope.settings = AccountingExportSettings.get({}, update);

    $scope.add = function () {
        $scope.extraFields.push({
            Input: undefined,
            Output: undefined,
            OutputTitle: undefined
        });
    };

    $scope.delete = function (i) {
        $scope.extraFields.splice(i, 1);
    };

    $scope.save = function () {
        if (!$scope.isValid($scope.form)) {
            $scope.notifyValidationError();
            return;
        }
        $scope.settings.$update({}, function () {
            $scope.notifySuccess();
            $scope.settings = AccountingExportSettings.get({}, update);
        });
    };
};
AccountingExportExtraFieldsController.$inject = ['$scope', 'AccountingExportAvailableFields', 'AccountingExportSettings'];
